export default __webpack_public_path__ + "static/international-metric-desktop-d09c403d43503c29afe4da87751e1c1a.svg";